export const datePickerFormat = 'YYYY-MM-DD';
export const datePickerParamName = 'date';
export const rangeDaysParamName = 'rangeDays';
export const defaultRangeDays = 14;
export const rangeDaysOptions = [7, 14, 30] as const;
